import React, { useEffect, useState } from 'react';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import { range } from '../../../helper';

const ExperienceForm = ({data, save}) => {
  
  const experienceValue = (v) => {
    let label;
    switch (String(v)) {
      case '0':
        label = "Less than 1"
        break;
      case '10':
        label = "10+"
        break;
      default:
        label = v
        break;
    }
    return label
  }
  const experienceLabel = (v) => {
    let label;
    switch (String(v)) {
      case '0':
        label = "Less than 1"
        break;
      case '10':
        label = "10+"
        break;
      default:
        label = v
        break;
    }
    return label
  }

return(<div className="screen-block">
{/* //Duplicate screen start  */}
  <div className="experience-list">
  {[...range(0, 10)].map((experience) => {
      return (
        <div className="exp-radio" key={`exp-${experience}`}>
          <input 
            type="radio" 
            id={`exp-${experience}`} 
            name="radio-group" 
            value={experience} 
            defaultChecked={experience == data.experience ? true : false}
            onChange={(e) => {
              // setUserExperience(e.target.value)
              save({ experience: e.target.value });
            }}
          />
          <label htmlFor={`exp-${experience}`}>{experienceLabel(experience)}</label>
        </div>
      )
    })
  }
  </div>
  {/* //Duplicate screen End  */}
 </div>)
}

export default ExperienceForm;